import React, {Component} from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import global_axios from '../../funciones_globales/interaccionapi';
import { formatearNumeroDecimal, formatearFechaMoment_a_String, formatearNumeroEntero } from '../../funciones_globales/format';
import styled from 'styled-components';
import { getItemDatosSesion, getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import ModalBusqueda from '../componentes_generales/modal_busqueda/modalBusqueda';
import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';

const LabelTotales = styled.label`
    display: inline-block;
    font-size: 11px;
    float: right;
`;

const LabelValorTotales = styled.label`
	display: inline-block;
	font-weight: bold;
    align-text: right;
    font-size: 11px;
    float: right;
`;

const ModalContainer = styled.div`
    margin-top: 20px;
    height: 400px;
    width: 520px;
`;

const Hr = styled.hr`
    margin-top: 10px;
    margin-bottom: 10px;
`;

class FormComp04 extends Component{
    constructor(props) {
		super(props);
		
		this.state = {
            accion: 'G',
            estadoPlanificacion: '',
            NroPropuesta: null,
            NroItemRowAyuda: null,
            modalBusqVisible: false,
            dataBusquedaProveedores: [],
            seleccionarTodos: false,
            totalPagar: 0,
            propuesta: '',
            fechaVencimiento: null,
            proveedoresFormaPago: false,
            facturasData: [],
            facturasColumnDefs:[
                {
                    header: "No.",
                    field: "NroItem",
                    width: 30,
                    type: "string",
                    suppressFilter: true
                },
                {
                    header: "",
                    field: "Selected",
                    width: 30,
                    checkboxSelection: true,
                    suppressSorting: true,
                    suppressMenu: true,
                    suppressFilter: true                    
                },
                {
                    header: "RUC",
                    field: "RUC",
                    width: 100,
                    type: "string",
                    suppressFilter: true
                },
                {
                    header: "Nombre",
                    field: "Nombre",
                    width: 195,
                    type: "string",
                    suppressFilter: true
                },
                {
                    header: "Doc.",
                    field: "Tipo",
                    width: 40,
                    type: "string",
                    suppressFilter: true
                },
                {
                    header: "Nro. Documento",
                    field: "NroDocumento",
                    width: 70,
                    type: "string",
                    suppressFilter: true
                },
                {
                    header: "Fecha Doc.",
                    field: "FechaDoc",
                    width: 75,
                    type: "string",
                    suppressFilter: true
                },
                {
                    header: "Saldo",
                    field: "Saldo",
                    width: 85,
                    type: "num_decimal",
                    suppressFilter: true
                },
                {
                    header: "Valor Pagar",
                    field: "ValorPagar",
                    width: 85,
                    type: "num_decimal_edit",
                    editable: true,
                    suppressFilter: true
                },
                {
                    header: "Fecha Vcto.",
                    field: "FechaVencimiento",
                    width: 75,
                    type: "string",
                    suppressFilter: true
                },
            ],
            pagosData: [],
            pagosColumnDefs:[
                {
                    header: "No.",
                    field: "NroItem",
                    width: 35,
                    type: "string",
                    suppressFilter: true
                },
                {
                    header: "RUC",
                    field: "RUC",
                    width: 95,
                    type: "string",
                    suppressFilter: true
                },
                {
                    header: "Nombre",
                    field: "Nombre",
                    width: 175,
                    type: "string",
                    suppressFilter: true
                },
                {
                    header: "Valor",
                    field: "ValorPagar",
                    width: 70,
                    type: "num_decimal",
                    suppressFilter: true
                },
                {   header: "",
                        field: "eliminar",
                        width: 60,
                        type: "link_elim"                                                
                    }
            ],
            modalDetalleVisible: false,
            tituloModalDetalle: '',
            dataDetalle: [],
            columnDefsDetalle: [
                {
                    header: "No.",
                    field: "NroItem",
                    width: 35,
                    type: "string",
                    suppressFilter: true
                },
                {
                    header: "Doc.",
                    field: "Tipo",
                    width: 50,
                    type: "string",
                    suppressFilter: true
                },
                {
                    header: "Nro. Documento",
                    field: "NroDocumento",
                    width: 75,
                    type: "string",
                    suppressFilter: true
                },
                {
                    header: "Fecha Doc.",
                    field: "FechaDoc",
                    width: 80,
                    type: "string",
                    suppressFilter: true
                },
                {
                    header: "Saldo a pagar",
                    field: "Saldo",
                    width: 90,
                    type: "num_decimal",
                    suppressFilter: true
                },
                {
                    header: "Valor a pagar",
                    field: "ValorPagar",
                    width: 90,
                    type: "num_decimal",
                    suppressFilter: true
                },
                {
                    header: "Fecha vencimiento",
                    field: "FechaVencimiento",
                    width: 80,
                    type: "string",
                    suppressFilter: true
                },
            ]
        };

        this.gridFacturasOptions = {
            enableColResize: true,
			enableSorting: true,
            enableFilter: true,
            rowSelection: "multiple",
            onRowSelected: this.validarSeleccion,
            suppressRowClickSelection: true,
            getRowStyle: (params) =>{
                if ( !params.data.FormaPago ) {
                  return {'background-color': '#faff87'}
                }
                return null;
            },
            onCellValueChanged: (event)=>{
                let valorAnterior = event.oldValue;
                let valorNuevo = event.newValue;

                if (event.colDef.field === 'ValorPagar'){
                    if(isNaN(valorNuevo) || parseFloat(valorNuevo)<=0){
                      alert('El valor a pagar que ingresó es incorrecto.');
                      event.data.ValorPagar = valorAnterior;
                    }else{
                        if(parseFloat(valorNuevo) >= parseFloat(event.data.Saldo)){
                            alert(`El valor a pagar no puede ser mayor que el saldo: ${formatearNumeroDecimal(event.data.Saldo)}`);
                            event.data.ValorPagar = event.data.Saldo;
                        }
                    }
                    this.gridFactutasApi.refreshCells();
                }
            }
        };

        this.gridPagosOptions = {
            context: {
                componentParent: this
            },
            enableColResize: true,
			enableSorting: true,
			enableFilter: true,
            rowSelection: "single",
        };
        
        this.onGridReadyFacturas = this.onGridReadyFacturas.bind(this);
        this.onGridReadyPagos = this.onGridReadyPagos.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.parseTipo = this.parseTipo.bind(this);
        this.getComprasPendientes = this.getComprasPendientes.bind(this);
        this.seleccionIndividual = this.seleccionIndividual.bind(this);
        this.seleccionGrupal = this.seleccionGrupal.bind(this);
        this.seleccionarTodos = this.seleccionarTodos.bind(this);
        this.validarSeleccion = this.validarSeleccion.bind(this);
        this.guardar = this.guardar.bind(this);
        this.getDataProveedores = this.getDataProveedores.bind(this);
        this.seleccionarProveedor = this.seleccionarProveedor.bind(this);
        this.onChangeFechaVencimiento = this.onChangeFechaVencimiento.bind(this);
        this.buscarPlanificacionPago = this.buscarPlanificacionPago.bind(this);
        this.eliminaDPlanifica = this.eliminaDPlanifica.bind(this);
        this.onClickProveedores = this.onClickProveedores.bind(this);
        this.showDetalleCompras = this.showDetalleCompras.bind(this);
        this.mostrarProvConFormasPago = this.mostrarProvConFormasPago.bind(this);
        this.imprimir = this.imprimir.bind(this);
    }
    
    componentDidMount(){        
        this.props.generar_LogAuditoriaIngresoForm('0604');
        let fechaProceso = getFechaProcesoPorModulo('06');
        this.setState({
            fechaVencimiento: moment(fechaProceso,'DD/MM/YYYY')
        }, () => this.getComprasPendientes());        
    }
    
    componentWillUnmount(){
		this.props.generar_LogAuditoriaSalidaForm('0604');
	}

	handleInputChange(event){    
		const target = event.target;       
		const name = target.name;    
		const value = target.type === 'checkbox' ? target.checked : target.value;
		this.setState({
			[name]: value
		});
    }
    
    onGridReadyFacturas(params){
        this.gridFactutasApi = params.api;
		this.gridFactutasColumnApi = params.columnApi;
    }

    onGridReadyPagos(params){
        this.gridPagosApi = params.api;
		this.gridPagosColumnApi = params.columnApi;
    }

    buscarPlanificacionPago(){
        let id = this.state.propuesta;

        if( !id ){
            alert("Ingrese el número de la propuesta");
            return;
        }
        this.props.cambiar_VisualizacionLoading(true);
        global_axios({
            method: 'GET',
            url: '/planificacionpago/' + id
        })
        .then( response => {
            if( !response.data.length ){
                this.props.cambiar_VisualizacionLoading(false);
                alert("No se encontraron datos");
                return;
            }

            let data = response.data[0];

            let fechaVencimiento = moment(data.FechaVencimiento,'YYYY-MM-DD');
            let pagosData = [];
            let totalPagar = 0;
            
            data.detalle.forEach((item, i) => {
                let index = 1;
                let detalle_compras = [];
                item.detalle.forEach((item2, key2) => {
                    detalle_compras.push({
                        Compra: item2.compra.Compra,
                        FechaDoc: formatearFechaMoment_a_String(item2.compra.FechaVencimiento),
                        FechaVencimiento: formatearFechaMoment_a_String(item2.compra.FechaVencimiento),
                        NroDocumento: item2.compra.Factura,
                        NroItem: index,
                        Saldo: item2.compra.SALDO,
                        Tipo: this.parseTipo(item2.compra.Tipo),
                        ValorPagar: item2.compra.SALDO,
                    });
                });
                index++;
                
                pagosData.push({
                    NroItem: (i + 1),
                    PlanificaPagoProvDetalleId: item.PlanificaPagoProvDetalleId,
                    proveedorId: item.IdentificacionBeneficiario,
                    Estado: item.Estado,                    
                    RUC: item.proveedor.IdentificacionCash,
                    Nombre: item.proveedor.Nombre,
                    ValorPagar: item.ValorPago,
                    detalle: detalle_compras,
                    tipoSeleccion: item.TipoSeleccion
                });
                totalPagar += item.ValorPago;
            });

            this.setState({
                fechaVencimiento,
                pagosData,
                totalPagar,
                accion: 'M',
                estadoPlanificacion: data.Estado,
                NroPropuesta: data.PlanificaPagoProvId,
            }, () => this.getComprasPendientes());

            this.props.cambiar_VisualizacionLoading(false);
        })
        .catch( error => {
            this.props.cambiar_VisualizacionLoading(false);
            alert("Ha ocurrido un error: " + error);
        });
    }

    parseTipo(tipo){
        switch(tipo){
            case "F":
                return "FAC";
            case "L":
                return "LQC";
            case "R":
                return "RCA";
            default:
                return "";
        }
    }

    onChangeFechaVencimiento(fechaVencimiento){
        if( !fechaVencimiento ){
            alert("La fecha ingresada es incorrecta");
            return;
        }
        
        if( !fechaVencimiento.isValid ){
            alert("La fecha ingresada es incorrecta");
            return;
        }

        this.setState({fechaVencimiento},
            () => this.getComprasPendientes()
        );
    }

    mostrarProvConFormasPago(){
        if( this.state.pagosData.length > 0 ){
            if( !window.confirm("Ya hay pagos seleccionados, si continúa se perderá la información.\n\r\t\t\t\t\t ¿Desea continuar?") ){
                return;
            }
        }
        this.setState({
            proveedoresFormaPago: !this.state.proveedoresFormaPago,
            pagosData: [],
            totalPagar: 0
        },
            () => this.getComprasPendientes('&formapagoNN=' + this.state.proveedoresFormaPago)
        )
    }

    getComprasPendientes(str = ""){
        let qs = "?compraspendientes=1&fechav=" + formatearFechaMoment_a_String(this.state.fechaVencimiento) + str;

        this.props.cambiar_VisualizacionLoading(true);
        global_axios({
            method: 'GET',
            url: '/compras/' + qs
        })
        .then( response => {
            let data = response.data;
            let facturasData = [];

            data.forEach((item, i) => {
                facturasData.push({
                    NroItem: (i+1),
                    proveedorId: item.proveedor.Proveedor,                    
                    RUC: item.proveedor.IdentificacionCash,
                    Nombre: item.proveedor.Nombre,
                    Tipo: this.parseTipo(item.Tipo),
                    TipoDoc: item.Tipo,
                    NroDocumento: item.Factura,
                    FechaDoc: formatearFechaMoment_a_String(item.FechaVencimiento),
                    Saldo: parseFloat(item.SALDO===null?0:item.SALDO).toFixed(2),
                    ValorPagar: parseFloat(item.SALDO===null?0:item.SALDO).toFixed(2),
                    FechaVencimiento: formatearFechaMoment_a_String(item.FechaVencimiento),
                    FormaPago: item.proveedor.FormaPago,
                    Compra: item.Compra
                });
            });

            this.setState({facturasData}, () => {
                this.gridFactutasApi.forEachNode(node => {
                    if( node.data.FormaPago !== null ){
                        node.setSelected(true);
                    }
                });
            });
            this.props.cambiar_VisualizacionLoading(false);
        })
        .catch( error => {
            this.props.cambiar_VisualizacionLoading(false);
            alert("Ha ocurrido un error: " + error);
        });
    }

    seleccionIndividual(){
        let facturas = this.gridFactutasApi.getSelectedRows();
        let predata = [];        
        let itemsQuitar = [];

        if( !facturas.length ){
            alert("Debe seleccionar al menos una factura");
            return;
        }

        facturas.forEach((item,i) => {
            predata[item.RUC] = [];
            predata[item.RUC]['detalle'] = [];
        });

        facturas.forEach((item,i) => {
            let key = item.RUC;

            predata[key]['RUC'] = item.RUC;
            predata[key]['Nombre'] = item.Nombre;
            predata[key]['ValorPagar'] = (predata[key]['ValorPagar']?parseFloat(predata[key]['ValorPagar']):0) + parseFloat(item.ValorPagar);
            predata[key]['detalle'].push(item);
            predata[key]['proveedorId'] = item.proveedorId;
            itemsQuitar.push(item.NroItem);
        });

        let data = this.state.pagosData;
        let pagosData = [];
        let NroItem = (data.length ? (data[data.length-1].NroItem+1) : 1 );
        for(let key in predata){
            pagosData.push({
                NroItem: (NroItem),
                proveedorId: predata[key].proveedorId,
                RUC: predata[key].RUC,
                Nombre: predata[key].Nombre,
                ValorPagar: predata[key].ValorPagar,
                detalle: predata[key].detalle,
                tipoSeleccion: "I",
                Estado: ""
            });
            NroItem++;
        }
        pagosData = data.concat(pagosData);

        let totalPagar = 0;
        pagosData.forEach(item => totalPagar+=item.ValorPagar);
        this.setState({pagosData, totalPagar});

        //Quitar elementos
        let facturasData = this.state.facturasData.filter(item => !(itemsQuitar.indexOf(item.NroItem) > -1));
        this.setState({facturasData});
    }

    seleccionGrupal(){
        let facturas = this.gridFactutasApi.getSelectedRows();
        let valor = 0;
        let detalle = [];
        let itemsQuitar = [];

        if( facturas.length === 0 ){
            alert("Debe seleccionar al menos una factura");
            return;
        }
        facturas.forEach((item) => {
            valor = parseFloat(parseFloat(valor) + parseFloat(item.ValorPagar)).toFixed(2);
            detalle.push(item);
            itemsQuitar.push(item.NroItem);
        });

        let data = this.state.pagosData;
        let NroItem = (data.length ? data[data.length-1].NroItem + 1: 1 );
        let pagosData = [];
        pagosData.push({
            NroItem: NroItem,
            proveedorId: "",
            RUC: "",
            Nombre: "",
            ValorPagar: parseFloat(valor).toFixed(2),
            detalle: detalle,
            tipoSeleccion: "G",
            Estado: ""
        });
        pagosData = data.concat(pagosData);

        let totalPagar = 0;
        pagosData.forEach(item => totalPagar+=parseFloat(item.ValorPagar));
        this.setState({pagosData, totalPagar});
        
        //Quitar elementos
        let facturasData = this.state.facturasData.filter(item => !(itemsQuitar.indexOf(item.NroItem) > -1));
        this.setState({facturasData});
    }

    seleccionarTodos(){
        this.gridFactutasApi.forEachNode(node => {
            if( node.data.FormaPago !== null ){
                node.setSelected(this.state.seleccionarTodos);
                this.setState({seleccionarTodos: !this.state.seleccionarTodos});
            }
        });
    }

    validarSeleccion(event){
        if( event.node.isSelected() ){
            let data = event.node.data;
            if( data.FormaPago === null ){
                event.node.setSelected(false);
                alert("El proveedor '" + data.Nombre + "' no tiene forma de pago")
            }
        }
    }

    onClickProveedores(){
        let row = this.gridPagosApi.getSelectedRows()[0];
        if( row ){
            if( row.Estado === "A" ){
                alert("Esta planificación ya fue aprobada, no se puede modificar");
                return;
            }
    
            if( row.tipoSeleccion === "G"){
                this.setState({modalBusqVisible: true, NroItemRowAyuda: row.NroItem});
                this.getDataProveedores();
            }else{
                alert("Solo puede elegir el beneficiario con Selección Grupal");
            }
        }
    }

    //Elimina una fila del grid
    methodFromParent(id, datos_fila){
        if( datos_fila.Estado && (datos_fila.Estado === "A" || datos_fila.Estado === "R") ){
            alert("Esta planificación ya fue aprobada, no se puede eliminar");
            return;
        }

        if( datos_fila.Estado && datos_fila.Estado === "P" ){
            if( window.confirm("¿Está seguro de eliminar el pago del beneficiario '" + datos_fila.Nombre + "' de la planificación?")){
                this.eliminaDPlanifica(id, datos_fila.PlanificaPagoProvDetalleId);
            }
            return;
        }
        //Elimina el item del grid Pagos Seleccionados
        let pagosData = this.state.pagosData.filter((item, key) => formatearNumeroEntero(key) !== formatearNumeroEntero(id));
        let totalPagar = 0;
        pagosData.forEach(item => totalPagar += item.ValorPagar);
        this.setState({pagosData, totalPagar});
        
        //Restaura el grid Facturas por pagar
        let facturasData = this.state.facturasData.concat(datos_fila.detalle);
        facturasData.sort((a,b) => a.NroItem > b.NroItem);

        this.setState({facturasData}, () => {
            this.gridFactutasApi.forEachNode(node => {
                if( node.data.FormaPago !== null ){
                    node.setSelected(true);
                }
            });
        });
    }

    eliminaDPlanifica(id_gridRow, detalle_id){
        this.props.cambiar_VisualizacionLoading(true);
        let id = this.state.propuesta;

        global_axios({
            method: 'PUT',
            url: '/planificacionpago/' + id + '/detalle/' + detalle_id,
        })
        .then( response => {
            this.props.cambiar_VisualizacionLoading(false);

            //Elimina el item del grid Pagos Seleccionados
            let pagosData = this.state.pagosData.filter((item, key) => formatearNumeroEntero(key) !== formatearNumeroEntero(id_gridRow));
            let totalPagar = 0;
            pagosData.forEach(item => totalPagar += item.ValorPagar);
            this.setState({pagosData, totalPagar});

            alert("El pago del beneficiario ha sido eliminado");
        })
        .catch( error => {
            this.props.cambiar_VisualizacionLoading(false);
            alert("Ha ocurrido un error: " + error);
        });
    }

    getDataProveedores(filter = ""){
        this.props.cambiar_VisualizacionLoading(true);
        global_axios({
            method: 'GET',
            url: '/proveedores?tipo=cash&cadena_busq=' + filter
        })
        .then( response => {
            this.props.cambiar_VisualizacionLoading(false);            
            let data = response.data;
            this.setState({dataBusquedaProveedores: data});
        })
        .catch( error => {
            this.props.cambiar_VisualizacionLoading(false);
            alert("Ha ocurrido un error: " + error);
        });
    }

    seleccionarProveedor(proveedor){        
        let pagosData = [];
        this.state.pagosData.forEach((item, i)=>{
            if( formatearNumeroEntero(item.NroItem) === formatearNumeroEntero(this.state.NroItemRowAyuda) ){
                item.proveedorId = proveedor.Codigo;
                item.Nombre = proveedor.Descripcion;                
                item.RUC = proveedor.IdentificacionCash;
            }
            pagosData.push(item);
        });

        this.setState({pagosData, modalBusqVisible: false}, () => this.gridPagosApi.refreshCells());
    }

    showDetalleCompras(){
        let row = this.gridPagosApi.getSelectedRows()[0];
        let detalle = [];

        if( row ){
            row.detalle.forEach((item,i) => {
                detalle.push({
                    ...item,
                    NroItem: (i+1),
                })
            });
            
            this.setState({
                modalDetalleVisible: true,
                dataDetalle: detalle,
                tituloModalDetalle: row.Nombre
            });
        }
    }

    limpiar(){
        let fechaProceso = getFechaProcesoPorModulo('06');
        this.setState({
            accion: 'G',
            estadoPlanificacion: '',
            NroItemRowAyuda: null,
            modalBusqVisible: false,
            dataBusquedaProveedores: [],
            seleccionarTodos: false,
            totalPagar: 0,
            propuesta: '',
            fechaVencimiento: moment(fechaProceso,'DD/MM/YYYY'),
            proveedoresFormaPago: false,
            facturasData: [],
            pagosData: [],
            modalDetalleVisible: false,
            tituloModalDetalle: '',
            dataDetalle: [],
        }, () => this.getComprasPendientes() );
    }

    guardar(){
        let pagos = this.state.pagosData;

        if( pagos.length === 0){
            alert("No hay datos para guardar");
            return;
        }
        
        let itemsPagoSinBeneficiario = [];
        for(let i in pagos){
            if( pagos[i].RUC.trim().length === 0 ){
                itemsPagoSinBeneficiario.push(pagos[i].NroItem);
            }
        }

        if (itemsPagoSinBeneficiario.length>0){            
            alert(`No ha especificado el beneficiario en los siguientes items de pago: ${itemsPagoSinBeneficiario.join('; ')}`);
            return;
        }

        let data = {};
        data.Usuario = getItemDatosSesion("usuario");
        data.FechaVencimiento = this.state.fechaVencimiento;

        let global_axios_config = {};

        if( this.state.accion === 'G' ){
            data.pagos = pagos;

            global_axios_config = {
                method: 'POST',
                url: '/planificacionpago/',
                data: data
            };
        }else{
            if( this.state.estadoPlanificacion === 'A' ){
                alert("La planificación ya ha sido aprobada, no se puede modificar");
                return;
            }
            data.pagos = pagos.filter(item => item.Estado === "");

            global_axios_config = {
                method: 'PUT',
                url: '/planificacionpago/' + this.state.propuesta + '?modificarPlanificacion=1',
                data: data
            };
        }
        this.props.cambiar_VisualizacionLoading(true);
        global_axios(global_axios_config)
        .then( response => {
            this.props.cambiar_VisualizacionLoading(false);
            let Nro;
            if(this.state.accion === 'G'){
                Nro = response.data.PlanificaPagoProvId;
            }else{
                Nro = this.state.propuesta;
            }            
            this.limpiar();            
            this.setState({NroPropuesta: Nro});
            alert("Se ha guardado la planificación #" + Nro);
        })
        .catch( error => {
            this.props.cambiar_VisualizacionLoading(false);
            alert("Ha ocurrido un error: " + error);
        });
    }

    imprimir(){
        if( this.state.NroPropuesta !== null ){
            let Nro = this.state.NroPropuesta;

            visualizarReporteEnPdf('&rpt=47&param1=' + Nro);
        }else{
            alert("No se encontró el número de planificación especificado.");
        }
    }

	render(){
		return(
			<ContenedorForm porc_ancho={98}>
				<HeaderForm>
					<TituloForm>Ingreso de planificación de pagos</TituloForm>
				</HeaderForm>
				<CuerpoForm>
                    <Row>
                        <ContainerCol className="col-sm-2">
                            <LabelForm>Propuesta Nro.</LabelForm>
                            <InputSearch
                                tipoInput='text'
                                nombre='propuesta'
                                placeholder='No. propuesta'
                                valor={this.state.propuesta}
                                func_CambiarValor={this.handleInputChange}
                                func_BuscarValor={this.buscarPlanificacionPago}
                                func_OnFocus={this.limpiar}
                            />
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className="col-sm-2">
                            <LabelForm>Fecha vencimiento</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaVencimiento} func_onChange={(fechaVencimiento)=>this.onChangeFechaVencimiento(fechaVencimiento)}/>
                        </ContainerCol>

                        <ContainerCol className="col-sm-3">
                            <LabelForm className="checkbox-inline">
                                <input type="checkbox" name="proveedoresFormaPago" checked={this.state.proveedoresFormaPago} onChange={this.mostrarProvConFormasPago} />
                                Mostrar sólo proveedores con Forma de Pago para Cash Management
                            </LabelForm>
                        </ContainerCol>
                    </Row>
					<Row>
                        <ContainerCol className="col-sm-8" style={{width: "63.667%"}}>
                            <LabelForm>Facturas por pagar</LabelForm>
                            <AgGridRender
								altura='381px'
								data={this.state.facturasData}
                                columnas={this.state.facturasColumnDefs}
                                
								onGridReady={this.onGridReadyFacturas}
								gridOptions={this.gridFacturasOptions}
							/>
                        </ContainerCol>

                        <ContainerCol className="col-sm-4" style={{width: "36.333%"}}>
                            <LabelForm>Pagos seleccionados</LabelForm>
                            <AgGridRender
								altura='381px'
								data={this.state.pagosData}
								columnas={this.state.pagosColumnDefs}
								onGridReady={this.onGridReadyPagos}
								gridOptions={this.gridPagosOptions}
							/>
                            
                            <LabelValorTotales> {formatearNumeroDecimal(this.state.totalPagar)}</LabelValorTotales>
                            <LabelTotales>Total a pagar: $ </LabelTotales>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className="col-sm-8">
                            <div className='btn-group pull-left btn-group-sm'> 
                                <button type='button' className='btn btn-default' onClick={this.seleccionIndividual}>
                                    Individual<i className='fa fa-angle-right fa-fw'></i>
                                </button>
                                <button type='button' className='btn btn-default' onClick={this.seleccionGrupal}>
                                    Grupal<i className='fa fa-angle-double-right fa-fw'></i>
                                </button>
                                <button type='button' className='btn btn-default' onClick={this.seleccionarTodos}>
                                    <i className='fa fa-check-square-o fa-fw'></i>Todos
                                </button>
                            </div>
                        </ContainerCol>
                        <ContainerCol className="col-sm-4">
                            <div className='btn-group pull-left btn-group-sm'>
                                <button type='button' className='btn btn-success' onClick={this.onClickProveedores}>
                                    <i className="fa fa-user-plus fa-fw"></i>
                                </button>
                                <button type='button' className='btn btn-default' onClick={this.showDetalleCompras}>
                                    <i className="fa fa-list fa-fw"></i>
                                </button>
                            </div>

                            <div className='btn-group pull-right btn-group-sm'>
                                <button type='button' className='btn btn-primary' onClick={this.guardar} disabled={this.state.estadoPlanificacion==='A'}>
                                    <i className="fa fa-save fa-fw"></i>Guardar
                                </button>                
                                <button type='button' className='btn btn-default' onClick={this.imprimir} disabled={this.state.NroPropuesta === null}>
                                    <i className="fa fa-print fa-fw"></i>Imprimir
                                </button>
                                <button type='button' className='btn btn-default' onClick={() => {this.setState({NroPropuesta: null}); this.limpiar()}}>
                                <i className="fa fa-trash fa-fw"></i>Limpiar
                                </button>
                            </div>
                        </ContainerCol>
                    </Row>

                    <ModalBusqueda
                        visible={this.state.modalBusqVisible}
                        title="Proveedores"
                        onClose={() => this.setState({modalBusqVisible: false})}
                        data={this.state.dataBusquedaProveedores}
                        onSelectedRow={(data) => this.seleccionarProveedor(data)}
                        onFilterData={(data) => this.getDataProveedores(data)}
                    />
				</CuerpoForm>

                <ModalResponsive open={this.state.modalDetalleVisible} onClose={() => this.setState({modalDetalleVisible: false})}>
                    <ModalContainer>
                        <Row>
                            <ContainerCol className='col-sm-12'>
                                <h4>{this.state.tituloModalDetalle}</h4>
                                <Hr />
                            </ContainerCol>
                        </Row>
                        <Row>
                            <ContainerCol className="col-sm-12">
                                <AgGridRender
                                    altura='300px'
                                    data={this.state.dataDetalle}
                                    columnas={this.state.columnDefsDetalle}
                                />
                            </ContainerCol>
                        </Row>
                        <Row>
                            <div className='col-sm-12'>
                                <div className="btn-group pull-right">
                                    <button type='button' className='btn btn-success btn-sm' onClick={() => this.setState({modalDetalleVisible: false})}><i className='fa fa-check fa-fw'></i> Aceptar</button>                                                
                                </div>
                            </div>
                        </Row>
                    </ModalContainer>
                </ModalResponsive>
			</ContenedorForm>
		);
	}
}

const mapStateToProps = ((state) => {
	return {
		isVisibleLoading: state.ui.isVisibleLoading, 		
		permiso: state.sesion.valoresSesionForm.Permiso,
		permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
		diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,
	};
});
  
const mapDispatchToProps = ((dispatch) => {  
	return bindActionCreators({
		cambiar_VisualizacionLoading,
		generar_LogAuditoriaIngresoForm,
		generar_LogAuditoriaSalidaForm,
	}, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormComp04);